import { render, staticRenderFns } from "./cider_menu.vue?vue&type=template&id=0d18882e&scoped=true"
import script from "./cider_menu.vue?vue&type=script&lang=js"
export * from "./cider_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18882e",
  null
  
)

export default component.exports